import { Link } from 'react-router-dom'
import { Layers } from 'lucide-react'

interface AuthLayoutProps {
  children: React.ReactNode
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex">
      {/* Left side - Form */}
      <div className="flex-1 flex flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:w-96">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 mb-8">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl gradient-bg">
              <Layers className="h-6 w-6 text-white" />
            </div>
            <span className="font-display font-bold text-xl">UnparkMyDomain</span>
          </Link>

          {children}
        </div>
      </div>

      {/* Right side - Decorative */}
      <div className="relative hidden lg:block lg:flex-1">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-secondary/20 to-accent/20" />
        <div className="absolute inset-0 pattern-grid" />

        {/* Content */}
        <div className="relative flex h-full flex-col justify-center px-12">
          <div className="max-w-md">
            <h2 className="text-3xl font-display font-bold mb-4">
              Turn idle domains into{' '}
              <span className="gradient-text">revenue machines</span>
            </h2>
            <p className="text-muted-foreground text-lg mb-8">
              AI-powered site generation that doesn't look like AI. Deploy professional
              landing pages, lead capture sites, and more in minutes.
            </p>

            {/* Features */}
            <div className="space-y-4">
              {[
                'AI analyzes your domain for best monetization strategy',
                'Professional designs that don\'t look generic',
                'Deploy directly to Cloudflare with one click',
                'Track leads and analytics in real-time',
              ].map((feature, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary/20 text-primary">
                    <svg
                      className="h-3 w-3"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={3}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <span className="text-sm text-muted-foreground">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
